export default __webpack_public_path__ + "static/media/Star5.9752fc50.svg";